export default {
  path: '/users/activity',
  name: 'UsersActivity',
  component: () => import(/* webpackChunkName: "base" */ '../views/UsersActivity.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
